import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        position: Number,
        id: String,
        activeSlide: Number,
        cardHeight: Number,
    }

    connect() {
        this._resizeObserver = new ResizeObserver(() => {
            if (this.element.classList.contains('active')) {
                window.dispatchEvent(new CustomEvent(`${this.idValue}-update-container-height`, {
                    detail: { height: this.element.offsetHeight }
                }));
            }
        });
        this._resizeObserver.observe(this.element);
    }

    disconnect() {
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            this._resizeObserver = null;
        }
    }

    toggleActiveSlide(event) {
        const {
            position,
        } = event.detail;

        if (this.positionValue === position) {
            this.element.classList.add('active');

            return window.dispatchEvent(new CustomEvent(`${this.idValue}-update-container-height`, {
                detail: {
                    height: this.element.offsetHeight,
                }
            }))
        } else {
            this.element.classList.remove('active');
        }
    }
}
